import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {endpoints} from 'main/tools';
import {Panel} from 'shared/components';
import {EmployeeTableSelector} from 'main/components';

const Employees = observer(({uiState}) => {
  const {schedule, errors} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.schedules.edit.steps.Employees')}
        description={t('time_tracking.manage.schedules.edit.Select the employees that will be included in this schedule.')}
      />
      <EmployeeTableSelector
        includedEmployees={schedule.employees}
        endpoint={endpoints.TIME_TRACKING.SCHEDULES.ELIGIBLE_EMPLOYEES.with(schedule.id)}
        onChange={employees => schedule.setEmployees(employees)}
        errorMessage={errors.employees}
      />
    </div>
  );
});

export default Employees;
